const hangover_subscription = {
  init: () => {
    const DEFAULTS = {
      LINK_TEXT: 'SHOP NOW',
      LINK_URL: '/pages/hangover-subscription-quiz?view=hangover-subscription-quiz'
    }
    const refs = {
      quizEl: document.querySelector('#shopify-section-hangover-subscription-hangover-buy-box'),
      buttonEls: document.querySelectorAll('a.btn-with-arrow')
    }
    refs.buttonEls.forEach((el) => {
      const textEl = el.querySelector('span')
      if (textEl) textEl.innerText = DEFAULTS.LINK_TEXT
      el.href = DEFAULTS.LINK_URL
    })
    if (refs.quizEl) refs.quizEl.style.display = 'none'
  }
};
export default hangover_subscription;